import React from "react";
import locationSrc from "@default/assets/ui/location.svg?url";

const IconLocation = () => {
  return <img src={locationSrc} alt={"Location"} className="icon location"/>;
}

export default IconLocation;